import React, { useState } from "react";
import { Input } from "../../../Helpers/Input/Input";
import RadioButton from "../../../Helpers/RadioButton/RadioButton";
import RequestComment from "./RequestComment";

const RequestPopupBody = () => {
  const [value, setValue] = useState(1);

  const options = [
    { label: "Low", value: "low" },
    { label: "Medium", value: "medium" },
    { label: "High", value: "high" },
    { label: "Severe", value: "severe" },
  ];

  return (
    <>
      <form className="h-form">
        <div className="userinfo mb-24">
          <div className="flex flex-row gap-16 w-100 mb-16">
            <Input
              title="Vehicle"
              type="text"
              placeholder="Volvo"
              formstyle="user-form w-100 flex-1"
              id="name"
              name="name"
              //   onBlur={addData.handleBlur}
              //   onChange={addData.handleChange}
              //   errors={addData.errors.name}
              //   touched={addData.touched.name}
              //   value={addData.values.name || ""}
            />
            <Input
              title="Maintenance type"
              type="text"
              placeholder="Regular"
              formstyle="user-form w-100 flex-1"
              id="distance"
              name="distance"
              //   onBlur={addData.handleBlur}
              //   onChange={addData.handleChange}
              //   errors={addData.errors.email}
              //   touched={addData.touched.email}
              //   value={addData.values.email || ""}
            />
          </div>

          <div className="flex flex-row gap-16 w-100 mb-16">
            <Input
              title="Workshop"
              type="text"
              placeholder="Workshop1"
              formstyle="user-form w-100 flex-1"
              id="remindDistance"
              name="remindDistance"
              //   onBlur={addData.handleBlur}
              //   onChange={addData.handleChange}
              //   errors={addData.errors.email}
              //   touched={addData.touched.email}
              //   value={addData.values.email || ""}
            />
            <Input
              title="Start Date"
              type="text"
              placeholder="11/10/2024"
              formstyle="user-form w-100 flex-1"
              id="time"
              name="time"
              //   onBlur={addData.handleBlur}
              //   onChange={addData.handleChange}
              //   errors={addData.errors.password}
              //   touched={addData.touched.password}
              //   value={addData.values.password || ""}
            />
          </div>
          <Input
            title="Description"
            type="text"
            placeholder="Description about"
            formstyle="user-form w-100 mb-16"
            id="description"
            name="description"
            //   onBlur={addData.handleBlur}
            //   onChange={addData.handleChange}
            //   errors={addData.errors.password}
            //   touched={addData.touched.password}
            //   value={addData.values.password || ""}
          />
          <RadioButton
            title={"Priority"}
            formstyle="user-form mb-16"
            options={options}
            value={value}
            setValue={setValue}
          />
        </div>
      </form>
      <RequestComment />
    </>
  );
};

export default RequestPopupBody;
